export const BASENAME = "/";
export const MAIN_PAGE = "/";
export const SIGN_IN_PAGE = "/sign-in";
export const ANONYMOUS_PAGES = ["/sign-in", "/sign-up", "/forgot", "/password-restored"];
